import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem
} from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { format } from 'date-fns';
import { useState } from "react";
import { useDispatch } from "react-redux";
import AssignmentModal from "./SideFeedComponents/AssignmentModal";
import { getOfferLetter, changeJobApplicationStatus, respondTheoffer } from "../../../Redux/Reducers/JobReducer";
import { Document, Page, pdfjs } from 'react-pdf';
import { ConstructionOutlined } from "@mui/icons-material";
import { useQuantityContext } from "../../QuantityContext";
import ApplicantOfferLetter from "./SideFeedComponents/ApplicantOfferLetter";



pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const ViewApplicantOfferLetter = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { applicant } = location.state || {};
  const offerLetters = useSelector((state) => state?.jobs?.OfferLetters) || [];
  // const offerLetters =  [];
  const navigate = useNavigate();
  // console.log("applicant123", applicant)
  // console.log('offerLetters', offerLetters);

  const { handleFailure, handleInfo, } = useQuantityContext();
  // States for modals and actions
  const [openPdfModal, setOpenPdfModal] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [declineDialog, setDeclineDialog] = useState(false);
  const [declineReason, setDeclineReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [pdfImage, setPdfImage] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [showPdfImage, setShowPdfImage] = useState(true);
  const [declineRemarks, setDeclineRemarks] = useState('');
  const [acceptDialog, setAcceptDialog] = useState(false);
  const [acceptRemarks, setAcceptRemarks] = useState('');
  const [isConverting, setIsConverting] = useState(false);
  const [viewType, setViewType] = useState('');
  const [conversionError, setConversionError] = useState(null);
  const REASONS = [
    'Got a better offer',
    'Not the right role',
    'Company culture mismatch',
    'Salary expectations not met',
    'Relocation issues',
    'Decided to pursue higher studies',
  ];
  const formatDate = (dateString) => {
    return format(new Date(dateString), 'dd MMMM yyyy');
  };

  // const handleViewOfferLetter = (offer) => {
  //   setSelectedOffer(offer);
  //   setOpenPdfModal(true);
  // };

  const handleAcceptOffer = async (offerLetters) => {
    try {
      setIsSubmitting(true);
      const payload = {
        application_id: offerLetters[0]?.application_id,
        action: "ACCEPT",
        applicant_remarks: acceptRemarks || "Excited to join the team!"
      }

      // console.log("payloadNNNNNNNNN", payload)

      await dispatch(respondTheoffer(payload)).unwrap();

      await dispatch(getOfferLetter(offerLetters[0]?.application_id));
      setAcceptDialog(false);
      navigate(-1);
    } catch (error) {
      console.error('Error accepting offer:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeclineOffer = async () => {
    try {
      setIsSubmitting(true);
      if (!declineReason) {
        handleInfo('Please select a reason for declining');
        return;
      }

      const payload = {
        application_id: selectedOffer?.application_id,
        action: "DECLINE",
        rejection_reason: declineReason,
        applicant_remarks: declineRemarks
      };

      // console.log("payloadNNN", payload)

      await dispatch(respondTheoffer(payload)).unwrap();
      setDeclineDialog(false);
      navigate(-1);
    } catch (error) {
      console.error('Error declining offer:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const isImageUrl = (url) => {
    return url.match(/\.(jpeg|jpg|gif|png)$/) !== null;
  };


  const convertPdfToImage = async (fileUrl) => {
    try {
      if (isImageUrl(fileUrl)) {
        setPdfImage(fileUrl);
        return fileUrl;
      }

      // Add proxy or base URL if needed
      const fullUrl = fileUrl.startsWith('http') ? fileUrl : `${process.env.REACT_APP_API_URL}${fileUrl}`;

      const loadingTask = pdfjs.getDocument({ url: fullUrl });
      const pdf = await loadingTask.promise;
      const page = await pdf.getPage(1);
      const scale = 1.5;
      const viewport = page.getViewport({ scale });

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };

      await page.render(renderContext).promise;
      const imageData = canvas.toDataURL('image/png');
      return imageData;
    } catch (error) {
      console.error('PDF conversion error:', error);
      throw new Error('Failed to convert PDF');
    }
  };


  const handleViewOfferLetter = async (offer, type) => {
    // try {
    setIsConverting(true);
    setViewType(type)
    setConversionError(null);
    setPdfImage(null);
    setSelectedOffer(offer);

    // if (!offer?.offer_letter_file) {
    //   throw new Error('No offer letter file available');
    // }

    // // Try to convert the PDF to image
    // try {
    //   const imageUrl = await convertPdfToImage(offer.offer_letter_file);
    //   setPdfImage(imageUrl);
    //   setShowPdfImage(true);
    // } catch (conversionError) {
    //   console.log('Falling back to PDF viewer:', conversionError);
    //   setShowPdfImage(false);
    //   // Even if conversion fails, we still show the PDF
    // }

    setOpenPdfModal(true);
    // } catch (error) {
    //   console.error('Error handling offer letter:', error);
    //   setConversionError('Error loading document. Please check the file format or try again.');
    // } finally {
    //   setIsConverting(false);
    // }
  };

  return (
    <Box sx={{ margin: '0 auto', p: 2, backgroundColor: '#f4f7fe', minHeight: "85vh" }}>
      {/* Header Section */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mb: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
         
        </Box>

        {/* Applicant Card */}

      </Box>
      <Box sx={{ display: 'flex', gap: 3 }}>
        {/* Offer Letters List */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '60%' }}>
          {applicant && (
            <Card sx={{ maxWidth: "900px", display: 'flex', p: 2, alignItems: 'center', gap: 3, boxShadow: 3 }}>
              <Box
                component="img"
                src={applicant?.company_logo || 'https://www.eventx.om/uploads/default-supplier-profile.jpg'}
                alt={applicant?.company_name || 'Company Logo'}
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: '50%',
                  objectFit: 'cover'
                }}
              />
              <Box sx={{ flex: 1 }}>
                <Typography variant="h6" fontWeight="bold">{applicant.company_name}</Typography>
                <Typography variant="body2" color="text.secondary">{applicant.role}</Typography>
                <Typography variant="body2" color="text.secondary" mt={1}>{applicant.email}</Typography>
                <Typography variant="body2" color="text.secondary">{applicant.phone}</Typography>
              </Box>

            </Card>
          )}
          {offerLetters?.map((offer) => (
            <Card sx={{ mb: 2, width: "100%", maxWidth: "100%" }} key={offer?.id}>
              <CardContent>
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, alignItems: 'flex-start', mb: 3 }}>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h5" sx={{ mb: 2 }}>{offer?.designation}</Typography>
                  </Box>
                  <Box>
                    {offer?.offer_letter_file && (
                      <Button
                        variant="contained"
                        onClick={() => handleViewOfferLetter(offer, 'offer')}
                      >
                        View Offer Letter
                      </Button>
                    )}
                  </Box>
                </Box>

                <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">CTC</Typography>
                    <Typography variant="body1">
                      ₹{
                        (() => {
                          const ctcValue = Number(offer?.ctc);
                          return !isNaN(ctcValue)
                            ? ctcValue.toLocaleString("en-IN")
                            : offer?.ctc;
                        })()
                      }
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">Date of Joining</Typography>
                    <Typography variant="body1">{formatDate(offer?.date_of_joining)}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">Status</Typography>
                    <Typography variant="body1">{offer?.status}</Typography>
                  </Box>
                  {offer?.remarks && (
                    <Box sx={{ gridColumn: { md: '1 / -1' } }}>
                      <Typography variant="subtitle2" color="text.secondary">Remarks</Typography>
                      <Typography variant="body1">{offer?.remarks}</Typography>
                    </Box>
                  )}
                </Box>
              </CardContent>
            </Card>
          ))}
        </Box>
        <Box  sx={{ width:"40%", height: "78vh", overflowX: "scroll", scrollbarWidth: "none" }}>
          <Box sx={{
          // minHeight: '50vh',
          // border: '2px solid gray',
          borderRadius: '8px',
         
          position: 'sticky',
        
          alignSelf: 'flex-start',
          display: { xs: 'none', lg: 'block' },
          overflow: 'hidden'
        }}>

          <ApplicantOfferLetter />
          
        </Box>
        </Box>
      </Box>
      {offerLetters?.length === 0 && (
        <Typography variant="h6" sx={{ textAlign: 'center', mt: 4 }}>
          No offer letters found
        </Typography>
      )}

      {/* PDF Viewer Modal */}
      {selectedOffer && (
        <AssignmentModal
          viewType={viewType}
          openPdf={openPdfModal}
          onClose={() => {
            setOpenPdfModal(false);
            setSelectedOffer(null);
          }}
          application_id={selectedOffer?.id}
          offer_letter_file={selectedOffer?.offer_letter_file}
          assignment_file_type={selectedOffer?.assignment_file_type}
        />
      )}

      {/* Decline Offer Dialog */}
      <Dialog
        open={acceptDialog}
        onClose={() => {
          setAcceptDialog(false);
          setAcceptRemarks('');
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Accept Offer</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Would you like to add any remarks while accepting the offer?
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            value={acceptRemarks}
            onChange={(e) => setAcceptRemarks(e.target.value)}
            placeholder="Enter your remarks (optional)"
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setAcceptDialog(false);
              setAcceptRemarks('');
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleAcceptOffer(offerLetters)}
            color="primary"
            variant="contained"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Accepting..." : "Accept Offer"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={declineDialog}
        onClose={() => {
          setDeclineDialog(false);
          setDeclineReason('');
          setDeclineRemarks('');
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Decline Offer</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>Please select a reason for declining:</Typography>
          <TextField
            select
            fullWidth
            required
            value={declineReason}
            onChange={(e) => setDeclineReason(e.target.value)}
            error={!declineReason}
            helperText={!declineReason ? "Reason is required" : ""}
            sx={{ mb: 3 }}
          >
            {REASONS.map((reason) => (
              <MenuItem key={reason} value={reason}>
                {reason}
              </MenuItem>
            ))}
          </TextField>

          <Typography sx={{ mb: 1 }}>Additional Remarks (Optional):</Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            value={declineRemarks}
            onChange={(e) => setDeclineRemarks(e.target.value)}
            placeholder="Enter any additional comments..."
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setDeclineDialog(false);
              setDeclineReason('');
              setDeclineRemarks('');
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeclineOffer}
            color="error"
            variant="contained"
            disabled={isSubmitting || !declineReason}
          >
            {isSubmitting ? "Declining..." : "Decline Offer"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ViewApplicantOfferLetter;